enum Lifestyle {
  Minimum = "Minimum",
  Moderate = "Moderate",
  Comfortable = "Comfortable"
}

export default Lifestyle;
